import Table from "../../league-table/Table"
import Stats from "./LeagueStats"
import { useLeague } from "../../../context/useLeague"
import { calculateTable } from "../../../utils/calculateTable"
import { useState, useEffect, FC } from "react"
import { TableEntry } from "../../../models/leagueStats"

const Tables: FC = ({}) => {
  const { league } = useLeague()
  const [tableEntries, setTableEntries] = useState<TableEntry[]>([]);

  useEffect(() => {
    if (league) {
      const newTableEntries = calculateTable(league.teams, league.fixtures);
      setTableEntries(newTableEntries);
    }
  }, [league]);

  return (
    <>
      <div className="container " id="custom-league-table">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-8 col-12 h-100 ">
            {/* League table */}
            <div className="gradient-gray curve-border">
              {tableEntries && league ? (
                <Table teams={tableEntries} division={league.division} />
              ) : null}
            </div>
          </div>
          {/* League statistics */}
          <div className="col-lg-4 col-12 " style={{ position: "relative" }}>
            <Stats />
          </div>
        </div>
      </div>
    </>
  )
}

export default Tables